'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useId } from '../hooks/useId';
import { PopoverContext } from './PopoverContext';
import { useControlled } from '@mui/material';
export const Popover = ({ children, id, isOpen, onClose, showClose = true }) => {
    const [open, setOpen] = useControlled({
        controlled: isOpen,
        default: false,
        name: 'Popover'
    });
    const anchorRef = React.useRef(null);
    const popoverId = useId(id, 'popover');
    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };
    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
        onClose?.();
    };
    const handleKeyDown = (event) => {
        if (event.key === 'Escape') {
            event.preventDefault();
            setOpen(false);
            onClose?.();
        }
    };
    const contextValues = {
        open,
        handleToggle,
        handleClose,
        handleKeyDown,
        popoverId,
        anchorRef,
        showClose
    };
    return (_jsx(PopoverContext.Provider, { value: contextValues, children: children }));
};
